import { createAction, handleActions } from "redux-actions";

const SET = 'answeringInfo.SET';
const CLEAR = 'answeringInfo.CLEAR';

const defaultState = {
  questionCountAccentClassName : '',
  accuracyLevel : 0,
  accuracyMessage : '',
  displayTime : '00:00'
};

const setAnsweringInfoAction = createAction( SET, payload => payload );
const clearAnsweringInfoAction = createAction( CLEAR );

const answeringInfo = handleActions( {
  [ SET ] : ( state, action ) => ( { ...state, ...action.payload } ),
  [ CLEAR ] : () => defaultState
}, defaultState );

export default answeringInfo;
export { setAnsweringInfoAction, clearAnsweringInfoAction };
